import React from "react";

export const MainPage = React.lazy(() => import("../Components/MainPage"));
export const HomePage = React.lazy(
  () => import("../Components/Pages/HomePage"),
);
export const ABOUT_US = React.lazy(() => import("../Components/Pages/AboutUs"));
export const CONTACT_US = React.lazy(
  () => import("../Components/Pages/ContactUs"),
);
export const PRODUCTS = React.lazy(
  () => import("../Components/Pages/Products"),
);
export const BLOG = React.lazy(() => import("../Components/Pages/Blogs"));

export const PRIVACY_POLICY = React.lazy(
  () => import("../Components/Pages/PrivacyPolicy"),
);
export const REFUND_POLICY = React.lazy(
  () => import("../Components/Pages/RefundCollection"),
);
export const TERM_CONDITION = React.lazy(
  () => import("../Components/Pages/Term"),
);
export const SUPPORT = React.lazy(() => import("../Components/Pages/Support"));
